import * as React from 'react';

import { formatPhoneNumber } from './formatPhoneNumber';
import { clearPhoneNumber } from './clearPhoneNumber';

export type TOnChange = (param: { cleanPhone: string; formattedPhone: string }) => void;

export interface IUsePhoneValueParams {
  onChange: TOnChange;
  initialValue?: string;
}

export const usePhoneValue = (params: IUsePhoneValueParams) => {
  const { initialValue } = params;

  const [value, setValue] = React.useState<string>(formatPhoneNumber(initialValue));

  const onChange = React.useCallback(
    (_value: string) => {
      const formattedPhone = formatPhoneNumber(_value);
      const cleanPhone = clearPhoneNumber(formattedPhone);
      setValue(formattedPhone);
      params.onChange({ cleanPhone, formattedPhone });
    },
    [params],
  );

  return {
    value,
    onChange,
  };
};
